import script from "./fy24.vue?vue&type=script&setup=true&lang=js"
export * from "./fy24.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__